import gradesApi from '../../api/grades.api'

// initial state
const state = {
  all: []
}

// getters
const getters = {
  allGrades: state => {
    return state.all
  }
}

// actions
const actions = {
  getAllGrades ({ commit }) {
    gradesApi.getGrades().then((res) => {
      const results = res.data.map((data) => {
        data.total_classes = data.sections.length
        data.total_subjects = data.subjects.length
        return data
      })
      commit('setGrades', results)
    })
  }
}

// mutations
const mutations = {
  setGrades (state, grades) {
    state.all = grades
  },

  setProducts (state, products) {
    state.all = products
  },

  decrementProductInventory (state, { id }) {
    const product = state.all.find(product => product.id === id)
    product.inventory--
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
